import React from 'react';
import { string, shape, arrayOf, number } from 'prop-types';
import CarouselFree, { CarouselFreeSlide } from '@andes/carousel-free';
import StyledLabel from '../styled-label';
import ModelsCard from './models-card';
import { trackEvent } from '../../lib/tracking';

const namespace = 'ui-vip-models-carousel';

const handleClick = (e, model) => {
  if (model.action) {
    trackEvent(model.action.track);
  }
  if (window.location.hash) {
    e.preventDefault();
    window.location = model.action.target + window.location.hash;
  }
};

// eslint-disable-next-line react/prop-types
const SlideModel = ({ model, ...rest }) => (
  <a
    className={`${namespace}__card_anchor`}
    // eslint-disable-next-line react/prop-types
    href={model.action && model.action.target}
    onClick={e => handleClick(e, model)}
  >
    <ModelsCard className={`${namespace}__model_card`} model={model} {...rest} />
  </a>
);

const ModelsCarouselMobile = ({ title, models }) => (
  <div className={namespace}>
    <StyledLabel className={`${namespace}__title`} as="h2" {...title} />
    <CarouselFree srLabel={title.text} spacing={16}>
      {models.map((model, i) => (
        <CarouselFreeSlide key={`model_${model.id}`} className={models.length - 1 === i ? 'last-card' : ''}>
          <SlideModel model={model} />
        </CarouselFreeSlide>
      ))}
    </CarouselFree>
  </div>
);

ModelsCarouselMobile.propTypes = {
  title: shape({
    text: string,
    color: string,
    font_size: string,
    font_family: string,
  }).isRequired,
  models: arrayOf(
    shape({
      id: number,
      image: shape({
        id: string,
        alt: string,
        width: number,
        height: number,
        url: shape({
          src: string,
          srcx2: string,
        }),
      }),
    }),
  ).isRequired,
};

export default React.memo(ModelsCarouselMobile);
